/* eslint-disable react-refresh/only-export-components */
import { ScrollArea } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { IconCheck, IconExclamationMark } from "@tabler/icons-react";
import { colors } from "../../styles/colors";

interface AlertProps {
  title?: string | React.ReactElement;
  message?: string | React.ReactElement;
  id?: string;
  autoClose?: number | false;
  color?: string;
  icon?: React.ReactElement;
}

type AlertFunction = (props: AlertProps) => void;

const AlertContent = (message: string | React.ReactElement) => (
  <ScrollArea mah={120} scrollbarSize={5} type="auto">
    {message}
  </ScrollArea>
);

export const showError: AlertFunction = ({
  title,
  message,
  autoClose = 5000,
  icon = <IconExclamationMark />,
}) =>
  notifications.show({
    autoClose,
    title,
    message: message && AlertContent(message),
    icon,
    styles: (theme) => ({
      icon: {
        backgroundColor: colors.errorColor
      }
    })
  });

export const showSuccess: AlertFunction = ({
  title,
  message,
  autoClose = 5000,
  icon = <IconCheck />,
}) =>
  notifications.show({
    autoClose,
    title,
    message: message && AlertContent(message),
    icon,
    styles: (theme) => ({
      icon: {
        backgroundColor: colors.successColor
      }
    })
  });
